import React, { useEffect } from 'react';
import PERMISSION_TYPES from '../../../../../../constants/consents/permissionTypes';
import { CONSENTS_FLOW } from '../../../../shared/onboardingConstants';
import { analyticsPageName, t } from '../../../../shared/onboardingUtils';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import ActionButton, { ACTIONS } from '../../../ActionButton/ActionButton';
import HeaderIcon from '../../../HeaderIcon';
import ModalBodyWithAlerts from '../../../ModalBodyWithAlerts';
import OnboardingModalActions from '../../../OnboardingModalActions';

import styles from './HealthDenialTwo.scss';
import gdprNoHealthIcon from './images/icon-gdpr-no-health.svg';

const HealthDenialTwo = () => {
  const { state, dispatch, track } = useOnboardingContext();
  const { alert } = state;

  useEffect(() => {
    track({
      page: analyticsPageName(CONSENTS_FLOW.health_denial_two),
      action: 'screen_enter'
    });
  }, [track]);

  const { stepForward, isProcessing } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });

  return (
    <>
      <ModalBodyWithAlerts alert={alert}>
        <HeaderIcon source={gdprNoHealthIcon} />
        <h2>{t('consents.health_denial_two.header')}</h2>
        <p>{t('consents.health_denial_two.description')}</p>
      </ModalBodyWithAlerts>
      <OnboardingModalActions>
        <ActionButton
          variant="default"
          onClick={() => stepForward({ action: ACTIONS.changedMyMind })}
          data-cy="health-denial-two-changed-mind-next-step-btn"
          className={styles.actionButton}
          focus={true}
        >
          {t('cta_actions.changed_my_mind')}
        </ActionButton>
        <ActionButton
          variant="primary"
          onClick={() =>
            stepForward({
              action: ACTIONS.approved,
              permissionType: PERMISSION_TYPES.health
            })
          }
          data-cy="health-denial-two-ok-next-step-btn"
          isProcessing={isProcessing}
          className={styles.actionButton}
        >
          {t('cta_actions.ok')}
        </ActionButton>
      </OnboardingModalActions>
    </>
  );
};

export default HealthDenialTwo;
